import Cookies from 'js-cookie';
import { clearSession } from './authService';
import { getSessionModules } from './sessionStore';

export function getGrantedModules() {
  return getSessionModules();
}

export function hasModule(moduleName) {
  if (!moduleName) {
    return false;
  }
  const modules = getGrantedModules();
  return modules.some(
    (m) => String(m).trim().toLowerCase() === String(moduleName).trim().toLowerCase()
  );
}

export function canAccess(moduleName) {
  if (hasModule(moduleName)) {
    return true;
  }
  clearSession();
  return false;
}

export function isAlumnoProfile() {
  try {
    const raw = Cookies.get('alumnoCodigos');
    if (!raw) {
      return false;
    }
    const codes = JSON.parse(raw);
    return !(codes.length === 1 && codes[0] === -1);
  } catch {
    return false;
  }
}